<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-left text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <div
      class="flex flex-row flex-nowrap justify-start space-x-1"
    >
      <template
        v-for="option in options"
        :key="option.value"
      >
        <button
          class="flex size-6 items-center justify-center rounded p-px"
          :style="{ backgroundColor: option.color }"
          type="button"
          @click="setColor(option.value)"
        >
          <template v-if="option.value === value">
            <IconDot class="size-full text-background" />
          </template>
        </button>
      </template>
      <button
        v-if="isClearable"
        class="flex size-6 items-center justify-center rounded bg-background-fg/30 p-0.5"
        type="button"
        @click="setColor(null)"
      >
        <IconX class="size-full text-background" />
      </button>
    </div>
    <p
      v-show="hasError"
      :class="[
        hasError ? 'text-error' : '',
        'mt-2 text-sm',
      ]"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = defineProps<{
  options: {
    label: string
    color: string
    value: string
  }[]
  name: string
  label: string
  isClearable?: boolean
}>()

const name = toRef(props, "name")

const { value, errorMessage, setValue } = useField<
  string | null
>(name, undefined, {})

const hasError = computed(() => !!errorMessage.value)

const setColor = (color: string | null) => {
  setValue(color)
}
</script>
